import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
// import PaymentViewModal from "./PaymentViewModal";
import { useSearchParams } from "react-router-dom";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import Select from "react-select";
import { dealerSignal } from "../../../signal/dealerSignal";
import PaymentViewModal from "./PaymentViewModal";
import PaymentAddEditModal from "./PaymentAddEditModal";
import { confirmAlert } from "react-confirm-alert";
import { organisationSignal } from "../../../signal/organisationSignal";
import TallyPaymentModal from "./TallyPaymentModal";
import { paymentsExcelGenerator } from "../../../utilities/excelGenerator";

export default function PaymentList() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [payments, setPayments] = useState([]);
    const [paymentToDisplay, setPaymentToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [dealerId, setDealerId] = useState(searchParams.get("dealerId") ? searchParams.get("dealerId") : "");
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [showPaymentViewModal, setShowPaymentViewModal] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [maxAmount, setMaxAmount] = useState(searchParams.get("maxAmount") ? parseFloat(searchParams.get("maxAmount")) : 0);
    const [minAmount, setMinAmount] = useState(searchParams.get("minAmount") ? parseFloat(searchParams.get("minAmount")) : 0);
    const [statusFilter, setStatusFilter] = useState(searchParams.get("statusFilter") ? searchParams.get("statusFilter") : "");
    const [showAddEditPayment, setShowAddEditPayment] = useState(false);
    const [showTallyPaymentModal, setShowTallyPaymentModal] = useState(false);

    const handleDisplayFields = () => {
        setPaymentToDisplay(payments.filter((item) => {

            if (minAmount && item?.amount < minAmount) return false;
            if (maxAmount && item?.amount > maxAmount) return false;
            if ((statusFilter && statusFilter !== "") && item.status !== statusFilter) return false;
            if (search === "") return true;
            if (item?.paymentType.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item?.remark.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item?.amount.toString().includes(search.toLowerCase())) {
                return true;
            } else if (item?.userId?.length > 0 && item?.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item?.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item?.reviewedBy?.length > 0 && item?.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item?.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item?.createdAt).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    const refetchPayments = () => {
        getPayments.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {
        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate, minAmount, maxAmount, statusFilter, dealerId, userId });
        setSearchParams(tempSearchParam);
        await getPayments.refetch({ cancelRefetch: true });
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields();
    }, [search, payments])

    const getPayments = useQuery("payments", async () => {
        let resp = await axios.get(`${DEV_SERVER}/payment/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&dealerId=${dealerId}&userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data

                if (stateName) {
                    temp = temp.filter((item) => {
                        if (item?.userId?.length > 0 && allUsersSignal.value[item?.userId[0]?.id]?.state === stateName) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                }

                setPayments(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updatePaymentStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/payment/v2/updateStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                refetchPayments();
                if (organisationSignal?.value && organisationSignal?.value?.isOrderModuleActivated && organisationSignal?.value?.isTallyIntegrationActivated && data?.data?.status === "cleared" && !data?.data?.isTallySynced) {
                    confirmAlert({
                        title: "Sync Payment with Tally?",
                        message: "Do you want to sync this payment with tally?",
                        buttons: [
                            {
                                label: "Yes",
                                onClick: () => {
                                    setShowTallyPaymentModal(true);
                                }
                            },
                            {
                                label: "No",
                                onClick: () => {
                                    return;
                                }
                            }
                        ]
                    })
                }
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const deletePaymentMutation = useMutation((id) => axios.delete(`${DEV_SERVER}/payment/v2/${id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                refetchPayments();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleDeletePayment = (id) => {
        confirmAlert({
            title: "Confirm to delete",
            message: "Are you sure you want to delete this payment?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        deletePaymentMutation.mutate(id);
                    }
                },
                {
                    label: "No",
                    onClick: () => {
                        return;
                    }
                }
            ]
        })
    }

    let updatePaymentStatus = (id, status, reason) => {
        updatePaymentStatusMutation.mutate({ id, body: { status, reason } })
    }

    useEffect(() => {
        refetchPayments();

    }, [])

    const handleRowClick = (row) => {
        setSelectedPayment(row);
        setShowPaymentViewModal(true);
    }

    const columns = [
        {
            name: "Dealer",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.dealerId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.dealerId[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)}>{row?.dealerId[0].name}</span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Remark",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remark}</Tooltip>}><span onClick={() => handleRowClick(row)}>{row?.remark}</span></OverlayTrigger>

            },
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: "amount",
            cell: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Payment Type",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.paymentType}</Tooltip>}>
                    <span onClick={() => handleRowClick(row)}>{row?.paymentType}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: "createdAt",
            cell: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "User",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.userId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId[0]?.name}</Tooltip>}>
                        <span onClick={() => handleRowClick(row)} style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={row?.userId[0].profileURL !== "" ? row?.userId[0].profileURL : avatar1} />
                            {row?.userId[0].name}
                        </span>
                    </OverlayTrigger>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "orange" : (row?.status === "cleared" ? "green" : "red") }}>{row?.status}</span>
        },

        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.reason === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.reason}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Cancel</Tooltip>}><i onClick={(e) => {
                    setSelectedPayment(row);
                    updatePaymentStatus(row?.id, "cancelled", text[row?.id])
                }} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Clear</Tooltip>}><i onClick={(e) => {
                    setSelectedPayment(row);
                    updatePaymentStatus(row?.id, "cleared", text[row?.id])
                }} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
            </span>
        },
        {
            name: "Operation",
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                    <span style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", opacity: row?.status === "pending" ? 1 : 0.5 }} onClick={() => {
                        if (row?.status !== "pending") {
                            return
                        }
                        setSelectedPayment(row);
                        setShowAddEditPayment(true);
                    }}><i className="far fa-edit table-icons"></i></span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                    <span style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", opacity: row?.status === "pending" ? 1 : 0.5 }} onClick={() => {
                        if (row?.status !== "pending") {
                            return
                        }
                        handleDeletePayment(row?.id)
                    }}><i className="far fa-trash-alt table-icons"></i></span>
                </OverlayTrigger>
                {(organisationSignal?.value && organisationSignal?.value?.isOrderModuleActivated && organisationSignal?.value?.isTallyIntegrationActivated) && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Sync with Tally</Tooltip>}>
                    <span style={{ cursor: row?.status === "cleared" && !row?.isTallySynced ? "pointer" : "not-allowed", opacity: row?.status === "cleared" && !row?.isTallySynced ? 1 : 0.5 }} onClick={() => {
                        if (row?.status !== "cleared" || row?.isTallySynced) {
                            return
                        }
                        setSelectedPayment(row);
                        setShowTallyPaymentModal(row);
                    }}><i className="fas fa-sync table-icons"></i></span>
                </OverlayTrigger>}
            </div>
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Payment List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                {dealerSignal?.value !== null && <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header><b>Filters</b></Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minAmount">Min Amount</label>
                                                    <input type="number" id="minAmount" className="form-control vanila-datepicker" names="start" placeholder="Min Amount" value={minAmount} onChange={(e) => {
                                                        setMinAmount(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">Max Amount</label>
                                                    <input type="number" id="maxAmount" className="form-control vanila-datepicker" names="start" placeholder="Max Amount" value={maxAmount} onChange={(e) => {
                                                        setMaxAmount(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">Dealer</label>
                                                    <Select
                                                        options={Object.keys(dealerSignal.value || {}).map((key) => {
                                                            return { value: dealerSignal.value[key].id, label: dealerSignal.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setDealerId(e.value);
                                                            } else {
                                                                setDealerId("");
                                                            }
                                                        }}

                                                        value={dealerSignal.value[dealerId] ? { value: dealerSignal.value[dealerId].id, label: dealerSignal.value[dealerId].name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">User</label>
                                                    <Select
                                                        options={Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setUserId(e.value);
                                                            } else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="statusFilter">Status</label>
                                                    <select value={statusFilter} onChange={(e) => {
                                                        setStatusFilter(e.target.value);
                                                    }} className="form-control">
                                                        <option value="">All</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="cleared">Cleared</option>
                                                        <option value="cancelled">Cancelled</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setMinAmount(0);
                                                    setMaxAmount(0);
                                                    setStatusFilter("");
                                                    setDealerId("");
                                                    setUserId("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, statusFilter: "", dealerId: "", userId: "" });
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>}
                                <div className="mt-3 px-2" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value)
                                        }} />
                                    </div>
                                    <div className="d-flex" style={{columnGap: "1rem"}}>
                                        <button className="btn btn-primary" onClick={() => {
                                            setSelectedPayment(null);
                                            setShowAddEditPayment(true);
                                        }}>Add Payment</button>
                                        <button className="btn btn-success"
                                        disabled={(getPayments.isFetching || getPayments.isLoading)}
                                        onClick={() => paymentsExcelGenerator(payments, `${"Payments"}-${fromDate}-${toDate}`)}
                                        >
                                            <svg id="SvgjsSvg1001" width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 18765 21993" width="20" height="20"><path fill-rule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white" class="color000 svgShape"></path></svg></g></svg> Export
                                        </button>
                                    </div>
                                </div>
                                {(!getPayments.isLoading && !getPayments?.isFetching) && <DataTable
                                    customStyles={
                                        {
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }
                                    }
                                    onRowClicked={(row) => {
                                        handleRowClick(row);
                                    }} columns={columns} data={paymentToDisplay} pagination={true} />}
                                {(getPayments.isLoading || getPayments?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showPaymentViewModal && <PaymentViewModal updatePaymentStatus={updatePaymentStatus} payment={selectedPayment} show={showPaymentViewModal} close={() => setShowPaymentViewModal(false)} />}

            {showAddEditPayment && <PaymentAddEditModal refetchPayments={refetchPayments} show={showAddEditPayment} close={() => setShowAddEditPayment(false)} payment={selectedPayment} />}

            {showTallyPaymentModal && <TallyPaymentModal refetchPayments={refetchPayments} payment={selectedPayment} show={showTallyPaymentModal} close={() => setShowTallyPaymentModal(false)} />}

        </>
    )
}